import React, { useCallback, useEffect, useState } from 'react';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import styles from './HistoryUninstall.module.less';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import LogOut from './LogOut';
import { getUserAppList } from '../../actions/uninstall';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { orderBy } from 'lodash-es';
import Config from './Uninstall.config';
import HistoryUninstallCard from './HistoryUninstallCard';
import { getMixBatchDetails } from '../../actions/uninstall';
import Loading from '../../components/Loading/Loading';
import Toast from '../../components/Toast/Toast';
import { logging, logPostInfo } from '../../actions/log';
import { downloadAddSoftList } from '../../actions/downloadTask';

const selectUninstall = createSelector(
  state => state.uninstall,
  uninstall => uninstall,
);

const selectNative = createSelector(
  state => state.native,
  native => native,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

function HistoryUninstall() {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const loginStatus = useLoginStatus();
  const [openBatch, setOpenBatch] = useState(false);
  const [batchList, setBatchList] = useState([]);
  const [downloadableList, setDownloadableList] = useState([]); // 可以下载的应用
  const [localUninstall, setLocalUninstall] = useState([]);
  const { installedSoft } = useSelector(selectNative);
  const upgradeSofts = useSelector(selectUpgradeSofts);
  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载

  const { handleInstallSoftNoFlilter } = Config;
  const {
    userAppList: appList,
    softsDetail: mixBatchDetails,
    appListLoading,
  } = useSelector(selectUninstall);
  const [selectList, setSelectlist] = useState([]);

  const startBatch = useCallback(
    startType => {
      if (!startType) {
        dispatch(
          logging({
            category: 'C',
            action: 'Apply_List_Batch',
            label: '',
            param2: {
              source: 'Mysoft_Batch',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );

        setOpenBatch(!startType);
        const arr = batchList.map(item => {
          return {
            ...item,
            openBox: !openBatch,
          };
        });
        setBatchList(arr);
      } else {
        if (selectList.length === 0) {
          Toast.error({ content: '请选择您要安装的应用' });
          return;
        } else {
          dispatch(
            logging({
              category: 'C',
              action: 'Apply_List_Install',
              label: '',
              param2: {
                source: 'Mysoft_Batch',
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
              },
            }),
          );

          const androidSoftList = [];
          const pcSoftList = [];
          selectList.forEach(softItem => {
            const upgrade = upgradeSofts.find(
              soft_ =>
                (soft_.androidType !== '1' &&
                  (soft_.softID === softItem.softID || soft_.SoftID === softItem.softID)) ||
                (soft_.androidType === '1' && soft_.packageName === softItem.packageName),
            );
            if (softItem && softItem.androidType === '1') {
              const logParam2 = {
                source: 'Mysoft_Batch',
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                softid: softItem.packageName,
                softName: softItem.softName,
                packageName: softItem.packageName,
                versionCode: softItem.versionCode,
                softType: '1',
                type: upgrade ? 'xu' : 'xd',
                url: softItem.downLoadUrl || softItem.downloadUrl,
              };
              androidSoftList.push({ ...softItem, logInfo: logParam2 });
            } else {
              const logParam2 = {
                source: 'Mysoft_Batch',
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                softid: softItem.softID,
                softName: softItem.softName,
                softType: '0',
                type: upgrade ? 'xu' : 'xd',
                url: softItem.downLoadUrl || softItem.downloadUrl,
              };
              pcSoftList.push({ ...softItem, logInfo: logParam2 });
            }
          });
          dispatch(downloadAddSoftList([...pcSoftList, ...androidSoftList]));
          const arr = batchList.map(item => {
            return {
              ...item,
              openBox: !openBatch,
            };
          });
          setBatchList(arr);
          setOpenBatch(false);
          setSelectlist([]);
        }
      }
    },
    [batchList, openBatch],
  );

  // 点击取消
  const handleClose = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Apply_List_Cancel',
        label: '',
        param2: {
          source: 'Mysoft_Batch',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    setOpenBatch(false);
    setSelectlist([]);
    const arr = batchList.map(item => {
      return {
        ...item,
        openBox: false,
        type: item.type === 2 ? 1 : item.type,
      };
    });
    setBatchList(arr);
  };

  // 处理单个应用选中
  const checkOneBox = useCallback(
    info => {
      const item = batchList.find(e => e.SoftID === info.SoftID);
      // const index = batchList.findIndex(e => e.softID === info.softID);
      let disposeArr = selectList.length > 0 ? selectList : [];
      if (item.type === 1) {
        const selectItem = { ...item, type: 2 };
        const sameIndex = disposeArr.findIndex(e => e.SoftID === selectItem.SoftID);
        if (sameIndex < 0) {
          disposeArr.push(selectItem);
        }
        const batchArr = batchList.map(i => {
          if (i.SoftID === item.SoftID) {
            return {
              ...i,
              type: 2,
            };
          } else {
            return i;
          }
        });
        setBatchList(batchArr);
        setSelectlist(disposeArr);
      } else {
        const tempIndex = disposeArr.findIndex(e => e.SoftID === item.SoftID);
        disposeArr.splice(tempIndex, 1);
        setSelectlist(disposeArr);
        const unBatchArr = batchList.map(i => {
          if (i.SoftID === item.SoftID) {
            return {
              ...i,
              type: 1,
            };
          } else {
            return i;
          }
        });
        setBatchList(unBatchArr);
      }
    },
    [batchList, selectList],
  );

  // 处理全选
  const handleCheckAll = useCallback(() => {
    if (selectList.length === downloadableList.length) {
      setSelectlist([]);
      const arr = batchList.map(item => {
        return item.type === 2 ? { ...item, type: 1 } : item;
      });
      setBatchList(arr);
    } else {
      const checkArr = downloadableList.map(item => {
        return { ...item, type: 2 };
      });
      const arr = batchList.map(item =>
        item.type === 1 && item.type !== 3 ? { ...item, type: 2 } : item,
      );

      setSelectlist(checkArr);
      setBatchList(arr);
    }
  }, [batchList, selectList]);

  // 获取所有的图片下载量以及获取所有备份
  useEffect(() => {
    const { andInstalled, pcInstalled } = handleInstallSoftNoFlilter(installedSoft);

    dispatch(
      getMixBatchDetails({
        params: {
          softIds: pcInstalled.map(item => item.SoftID).filter(item => item),
          pns: andInstalled.map(item => item.packageName).filter(item => item),
        },
      }),
    );
  }, []);

  // 备份应用根据登录状态来刷新
  useEffect(() => {
    if (loginStatus) {
      dispatch(getUserAppList());
    } else {
      setBatchList([]);
    }
  }, [loginStatus]);

  // 处理后台获取备份数据以及本地数据合并混排
  useEffect(() => {
    // const { andInstalled, pcInstalled } = handleInstallSoftNoFlilter(installedSoft);
    let arr = installedSoft;
    // 将每个应用附加上详情
    // for (let i = 0; i < arr.length; i++) {
    //   for (let j = 0; j < mixBatchDetails.length; j++) {
    //     arr[i] = { ...arr[i], local: 1, openBox: openBatch, type: 3 };
    //     if (arr[i].SoftID === mixBatchDetails[j].softID) {
    //       arr[i] = {
    //         ...arr[i],
    //         introduction: mixBatchDetails[j].introduction,
    //         downloadCount: mixBatchDetails[j].downloadCount,
    //         logoFile: mixBatchDetails[j].logoFile,
    //       };
    //     }
    //   }
    // }
    // 给每个本地的应用添加上详细信息
    arr.forEach((i, index) => {
      mixBatchDetails.forEach((j, index2) => {
        if (i.SoftID === j.softID) {
          arr[index].introduction = mixBatchDetails[index2].introduction;
          arr[index].downloadCount = mixBatchDetails[index2].downloadCount;
          arr[index].logoFile = mixBatchDetails[index2].logoFile;
        }
        arr[index] = { ...arr[index], local: 1, openBox: openBatch, type: 3 };
      });
    });

    // 处理特殊的应用
    // for (let i = 0; i < arr.length; i++) {
    //   for (let j = 0; j < appList.length; j++) {
    //     if (arr[i].SoftID === appList[j].SoftID) {
    //       arr[i] = {
    //         ...arr[i],
    //         introduction: appList[j].introduction,
    //         downloadCount: appList[j].downloadCount,
    //         logoFile: appList[j].logoFile,
    //       };
    //     }
    //   }
    // }
    arr.forEach((i, index) => {
      appList.forEach((j, index2) => {
        if (i.SoftID === j.SoftID) {
          arr[index].introduction = appList[index2].introduction;
          arr[index].downloadCount = appList[index2].downloadCount;
          arr[index].logoFile = appList[index2].logoFile;
        }
      });
    });

    let backupList = appList.map(item => {
      return {
        ...item,
        openBox: openBatch,
        type: 1,
      };
    });

    // 判断当前是否有软件正在下载
    let softsF = downloadSofts.filter(item => {
      return item.attr && item.attr.status !== 'exitq';
    });
    if (softsF.length > 0 && selectList.length > 0) {
      let selectArr = selectList;
      selectArr.forEach((i, index) => {
        softsF.forEach(j => {
          if (j.attr.act !== 'error') {
            if (Reflect.has(j, 'pc')) {
              if ((i && i?.SoftID) === (j && j?.[j?.type]?.SoftID)) {
                selectArr.splice(index, 1);
              }
            } else {
              if ((i && i?.softName) === (j && j?.[j?.type]?.SoftName)) {
                selectArr.splice(index, 1);
              }
            }
          }
        });
      });
      setSelectlist(selectArr);
    }
    // 讲当前下载的应用进行匹配放入后台获取的备份数组中
    backupList.forEach((i, index) => {
      softsF.forEach(j => {
        if (j.attr.act !== 'error') {
          if (Reflect.has(j, 'pc')) {
            if ((i && i?.SoftID) === (j && j?.[j?.type]?.SoftID)) {
              backupList[index].type = 3;
            }
          } else {
            if ((i && i?.softName) === (j && j?.[j?.type]?.SoftName)) {
              backupList[index].type = 3;
            }
          }
        }
      });
    });

    // 如果刚刚好下载完成 并且还有选择的时候
    if (selectList.length > 0) {
      backupList.forEach((i, index) => {
        selectList.forEach(j => {
          if ((i.SoftID === j.SoftID ?? j.softID) && i.type !== 3) {
            backupList[index].type = 2;
          }
        });
      });
    }

    const newArr = orderBy(
      backupList.filter(j => {
        return !arr.map(v => v.softID ?? v.SoftID).includes(j.softID ?? j.SoftID);
      }),
      ['backupTime'],
      ['desc'],
    );

    setLocalUninstall(newArr);
    // 排序前再过滤一次
    const arr1 = arr.filter(i => i.downloadCount);

    const vaildArr = orderBy(
      arr1.filter(i => i.softID ?? i.SoftID),
      ['sortTime1', 'sortSize', 'displayName'],
      ['desc'],
    );
    // 获取一个当前可下载的数组
    const Arr = newArr.filter(i => i.type !== 3);
    setDownloadableList(Arr);
    setBatchList([...newArr, ...vaildArr]);
  }, [installedSoft, appList, mixBatchDetails, downloadSofts, selectList]);

  return (
    <div className={styles.page} pagescroll="PCStore_Page_Scroll">
      {loginStatus && (
        <>
          {/* {appListLoading && <Loading />}
           */}
          {batchList.length <= 0 && appListLoading && <Loading />}
          {/* {!appListLoading && ( */}
          {batchList.length > 0 && !appListLoading && (
            <div className={styles.page_container}>
              <div className={styles.header}>
                {openBatch && (
                  <div className={styles.check_all}>
                    <div
                      className={
                        selectList.length === downloadableList.length
                          ? `${styles.checked}`
                          : `${styles.check}`
                      }
                      onClick={handleCheckAll}
                    />
                    <div>
                      全选（已选中<span className={styles.select_num}>{selectList.length}</span>{' '}
                      款应用）
                    </div>
                  </div>
                )}
                {!openBatch && <div className={styles.header_text}>以下为你历史安装过的应用</div>}

                <div className={styles.right_operation}>
                  {openBatch && (
                    <div onClick={handleClose} className={styles.cancel}>
                      取消
                    </div>
                  )}
                  {/* {downloadableList.length > 0 && localUninstall.length !== 0 && ( */}
                  {localUninstall.length !== 0 && (
                    <div
                      className={`${styles.install_btn} ${
                        selectList.length === 0 && openBatch ? styles.install_btn_disable : ''
                      }`}
                      onClick={() => startBatch(openBatch)}
                    >
                      {openBatch ? '开始安装' : '批量安装'}
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.content}>
                {batchList?.map((item, i) => (
                  <HistoryUninstallCard key={i} info={item} enabled={checkOneBox} />
                ))}
              </div>
            </div>
          )}
        </>
      )}
      {!loginStatus && <LogOut />}
    </div>
  );
}

export default () => <HistoryUninstall />;
